import {LevelFilter} from "../../../../services/classes/MatReviewClasses";
import {SelectionIds} from "../../../../components/visualization/api-dropdown-filter/ApiDropdownTypes";


export type BasePpvFilter = {
    // Required
    databag: number

    // Optional
    business_unit: null | number | undefined
    quarter_date__gte?: string // start
    quarter_date__lte?: string // end

    // IN-filters use django: filterset_fields 'in' filters
    // NOT-filters use django: ModelMultipleChoiceFilter
    //   (Needs to be repeated in QueryParams, Axios.paramsSerializer: {indexes: null})
    // TODO: Move both to ModelMultipleChoiceFilter to make sure "," can be used in the string fields
    supplier_id__in?: string
    supplier_id__not?: number[]
    cc_description__in?: string
    cc_description__not?: string[]
    business_unit_id__in?: string
    business_unit_id__not?: number[]
    p_name__in?: string
    p_name__not?: string[]

    // p_description__in?: string // Not possible as there are ',' in descriptions
}

export function extractOptionFromInclExclFilter(filter: BasePpvFilter, field: string): SelectionIds | null {
    const incl = filter[`${field}__in`] as string | undefined;
    const excl = filter[`${field}__not`] as string[] | undefined;
    if (incl) {
        return {inclusive: true, selected: incl.split(',').map(o => ({id: o}))}
    }
    if (excl) {
        return {inclusive: false, selected: excl.map(o => ({id: o}))}
    }
    return null;
}

export type PpvAllLevelsFilter = BasePpvFilter;

/**
 * Complete filter on the PPV data model
 */
export type PpvFilter = LevelFilter & BasePpvFilter

export type PpvGroupFilter = PpvFilter & {
    search: string | undefined
    page: number
    page_size: number
}


/**
 * Filter for a list of PPV Data Items underneath a PpvGroup
 */
export type PpvItemListFilter = PpvFilter & {
    p_name: string // ppv_key
    no_page: true
}

/**
 * This selects a single item
 */
export type PpvItemDeletionFilter = PpvFilter & {
    p_name: string // ppv_key

    p_description: string
    supplier_id: number
    cc_description: string
}

export type PpvSupplierSearchResponse = {
    id: number
    databag_id: number
    s_id: string
    s_name: string
}

export type PpvBusinessUnitSearchResponse = {
    id: number
    databag_id: number
    bu_id: string
    bu_name: string
}

export type PpvCcDescriptionSearchResponse = {
    cc_description: string
}

export type PpvPNameSearchResponse = {
    p_name: string
}
